import React, { FC } from 'react';
import {
	SummaryBeantragteFoerderquote,
	SummaryBeantragteFoerderung,
	SummaryDatumDerEinreichung,
	SummaryGeplanteProjektAusgabe,
	SummaryNameDerOrganisation,
	SummaryOrganisationAntragberechtigtAls,
	SummaryProjektTitel,
	SummaryTitel,
} from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteSummary';
import AbschlussSeiteBox from '../../../../antrag-components/AbschlussSeiteBox';

const AbschlussAntragEpz: FC<{}> = () => {
	return (
		<>
			<SummaryTitel />
			<AbschlussSeiteBox>
				<SummaryDatumDerEinreichung />
				<SummaryProjektTitel />

				<SummaryNameDerOrganisation />
				<SummaryOrganisationAntragberechtigtAls />

				<SummaryGeplanteProjektAusgabe />
				<SummaryBeantragteFoerderung />
				<SummaryBeantragteFoerderquote />
				{/* <GefoerderteSummeProgrammInfo application={application} /> */}
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussAntragEpz;
